export default __webpack_public_path__ + "static/sessionsNew-8d9cca039514673a415a2933831672dd.jpg";